module.exports = __webpack_public_path__ + "assets/images/project/germany.jpg?v=a76dbc65";